import { Tabs, Tab } from '../../../../../components';
import { CallTranscript } from './CallTranscript';

type TabsEnum = 'transcript' | 'previousCalls';

export const CallDetailsTabs = () => {
  return (
    <div className="h-full">
      <Tabs<TabsEnum>
        tabs={[
          { name: 'transcript', label: 'Transcript' },
          { name: 'previousCalls', label: 'Previous Calls' },
        ]}
        contentClassName="mt-md h-full overflow-y-auto"
        tabClassName="text-tiny font-semibold p-0"
        className="h-full"
      >
        <Tab name="transcript">
          <CallTranscript />
        </Tab>
        <Tab name="previousCalls">
          <div>Previous Calls</div>
        </Tab>
      </Tabs>
    </div>
  );
};
